// Quantity DISPLAY formatting only — mirrors money.js's "never round-trip a
// DECIMAL through a float" caution, but for request_lines.qty /
// quotation_lines.qty, which are DECIMAL(12,3). mysql2 returns them as
// strings like "1.000" (no `decimalNumbers` option set on
// backend/src/db/pool.js). Printing that string as-is reads as a thousands
// separator on a countable unit ("1.000 pcs"), so show a fractional part
// only when the quantity actually has one: "1", "45" stay whole, but "2.5"
// (kg, say) keeps its decimal.
export function formatQty(value) {
  if (value === null || value === undefined || value === '') return '';
  const str = String(value).trim();
  const negative = str.startsWith('-');
  const unsigned = negative ? str.slice(1) : str;
  const [wholePartRaw, fracPartRaw = ''] = unsigned.split('.');
  const wholePart = wholePartRaw === '' ? '0' : wholePartRaw;
  const fracPart = fracPartRaw.replace(/0+$/, '');
  const result = fracPart.length > 0 ? `${wholePart}.${fracPart}` : wholePart;
  return negative ? `-${result}` : result;
}

export default formatQty;
